import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import type { ReactNode } from 'react';

import FromNow from '../../../generic/FromNow';

/**
 * Format the date string to the following formats:
 *  - If the date is less than a day old, format it using formatDistanceToNow (e.g, a few seconds ago).
 *  - If the date is older than a day, format it to a GMT date (e.g, 7/10/23 at 12:58 PM GMT).
 *  - If the date is undefined, return an empty string.
 */
export function formatDate(date?: string): ReactNode {
  if (!date) {
    return '';
  }
  const inputDate = new Date(date);
  const differenceInDays = Math.abs(new Date().getDate() - inputDate.getDate());

  if (differenceInDays > 0) {
    const gmtDate = toZonedTime(inputDate, 'Etc/Greenwich');
    return format(gmtDate, 'MM/dd/yy \'at\' h:mm a \'GMT\'');
  }

  return <FromNow date={inputDate} />;
}
